import { render, staticRenderFns } from "./checkBankCard.vue?vue&type=template&id=895cceda"
import script from "./checkBankCard.vue?vue&type=script&lang=js"
export * from "./checkBankCard.vue?vue&type=script&lang=js"
import style0 from "./checkBankCard.vue?vue&type=style&index=0&id=895cceda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports